export default "__VITE_ASSET__DYSORPE3__"